<template>
  <div class="poster" v-if="isLoad">
    <div class="title">恭喜你！</div>

    <div class="image">
      <img :src="imgPath" width="300px">
    </div>

    <clazz-card v-if="!posterUrl" ref="clazzPoster" :poster-data="posterData" @success="success" @fail="fail" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
import ClazzCard from '@/components/Poster/ClazzCard'
import { getMyClazzCard, setMyClazzCard, getMyClazzCardData } from '@/api/clazz'
import { uploadImageToOss } from '@/api/upload'
import { getUploadParams, base64ToFile } from '@/utils/upload'

export default {
  name: 'clazzcard',
  components: {
    ClazzCard
  },
  data () {
    return {
      isLoad: false,
      clazzId: null,
      imgPath: '',
      posterUrl: null,
      posterData: null
      // posterData: {
      //   bg_img: 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/test/poster_template/rule_card/20230607/1686108002919.jpg',
      //   // clazz_name: '365一起跑100天2公里官方班202306期',
      //   clazz_name: '班级名称班级名称班级名称班级名称班级名称',
      //   time_range: '20230101 - 20230410',
      //   clazz_distance: 2,
      //   days: 200,
      //   distance: 111,
      //   duration: 2222,
      //   pace: '06:30',
      //   rank: 10,
      //   creator: '班长班长班长班长班长班长'
      // }
    }
  },
  computed: {
    ...mapGetters([
      'ossToken'
    ])
  },
  created () {
    this.clazzId = this.$route.query.clazz_id
    if (this.clazzId) {
      this.getPoster()
    }
  },
  methods: {
    async getPoster () {
      const res = await getMyClazzCard({ clazz_id: this.clazzId })
      this.posterUrl = res.data.poster_url
      if (!this.posterUrl) {
        this.getPosterData()
      } else {
        this.imgPath = this.posterUrl
        this.isLoad = true
      }
    },
    async getPosterData () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      const res = await getMyClazzCardData({
        clazz_id: this.clazzId
      })
      this.posterData = res.data
      this.isLoad = true
    },
    success (src) {
      Toast.clear()
      this.imgPath = src
      if (!this.posterUrl) {
        const file = base64ToFile(src, 'poster.png')
        this.upload(file)
      }
    },
    fail (err) {
      Toast.clear()
      console.log('fail', err)
    },
    async upload (fileObj) {
      await this.$store.dispatch('GetOssToken', 'record_poster')
      const formData = getUploadParams(this.ossToken, fileObj)

      await uploadImageToOss(this.ossToken.host, formData)
      const filePath = formData.get('key')
      await setMyClazzCard({
        clazz_id: this.clazzId,
        poster: filePath
      })
    }
  }
}
</script>

<style lang="scss">
.poster {
  .title {
    padding: 60px 0 20px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .image {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
